const styles = theme => ({
  margin: {
    margin: theme.spacing.unit
  },
  bootstrapRoot: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 14,
    padding: '6px 12px',
    border: '1px solid',
    backgroundColor: 'white',
    borderColor: '#189A44',
    color: '#189A44',
    fontFamily: [
      'Lato',
      'sans-serif'
    ].join(','),
    '&:hover': {
      backgroundColor: '#189A44',
      borderColor: '#189A44',
      border: '1px solid',
      color: 'white'
    }
  },
  avatar: {
    margin: 10
  },
  orangeAvatar: {
    color: 'white',
    backgroundColor: '#189A44',
    borderColor: '#189A44',
    width: 38,
    height: 38,
    '&:hover': {
      backgroundColor: '#F9F9F9',
      border: 'solid 1px',
      borderColor: '#189A44',
      color: '#189A44'
    }
  },
  navbar: {
    fontWeight: 'bold',
    fontSize: '16px',
    letterSpacing: '1px',
    color: '#333'
  },
  logo: {
    marginTop: '-1%',
    marginLeft: '2%',
    marginRight: '65px !important'
  },
  header: {
    marginLeft: '144px',
    marginTop: '53px',
    height: '78px'
  },
  navigation: {
    border: 'none !important',
    backgroundColor: 'initial'
  },
  typography: {
    fontFamily: 'Univia Pro',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#3A3A3A',
    padding: '10px'
  },
  menu: {
    fontFamily: 'Univia Pro',
    fontSize: '12px',
    fontWeight: '900',
    color: '#ffffff',
    padding: '10px'
  },
  buttonsMenu: {
    gap: '15px',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  loginButton: {
    lineHeight: '40px',
    border: '1px solid #004E98',
    display: 'inline-block',
    borderRadius: '10px',
    width: '75%',
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.up('lg')]: {
      width: '147px'
    },
    height: '47px',
    textAlign: 'center',
    opacity: 1,
    '& p': {
      lineHeight: '34px',
      padding: '5px 0',
      fontWeight: 'bold',
      fontSize: '14px',
      color: '#004E98',
      display: 'block'
    }
  },
  registerButton: {
    lineHeight: '40px',
    border: '1px solid #004E98',
    display: 'inline-block',
    borderRadius: '10px',
    width: '75%',
    [theme.breakpoints.up('lg')]: {
      width: '147px'
    },
    height: '47px',
    textAlign: 'center',
    opacity: 1,
    background: '#004E98',
    '& p': {
      lineHeight: '34px',
      padding: '5px 0',
      color: '#fff',
      fontWeight: 'bold',
      fontSize: '14px',
      display: 'block'
    }
  }
});

export default styles;
